
export const SurveyScoreValues = [1, 2, 3, 4, 5] as const;
export type SurveyScore = typeof SurveyScoreValues[number];

